import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=316d4388&scoped=true&lang=pug"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.styl?vue&type=style&index=0&id=316d4388&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d4388",
  null
  
)

export default component.exports